import styled from "styled-components";

export const QueryFormContainer = styled.div(
  (props) => `
    background: rgba(0,0,0,0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999999;
    left: 0;
    top: 0;
    overflow: scroll;
    scroll-behavior: smooth;

    div.outer {
        padding: 0;
        max-width: 1200px;
        margin: 0 auto;
        margin-top: 5%;

        div.contactManagementContainer {
            width: 520px;
            background: #fff;
            padding: 25px 25px;
            border-radius: 4px;
            position: absolute;
            left: 50%;
            top: 100px;
            transform: translateX(-50%);
            z-index: 9999;
            margin-bottom: 100px;

            div.contactManagementHdr {
                padding: 0;
                margin: 0;
                color: #4a4a4a;
                font-size: 14px;
                font-weight: 400;
                font-family: 'Rubik';

                p.closePopup {
                    position: fixed;
                    top: 26px;
                    right: 35px;
                    width: 18px;
                    height: 18px;
                    cursor: pointer;
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                p.closePopup:before {
                    transform: rotate(45deg);
                    position: absolute;
                    left: 8px;
                    content: ' ';
                    height: 18px;
                    width: 2px;
                    background-color: #000;
                }

                p.closePopup:after {
                    transform: rotate(-45deg);
                    position: absolute;
                    left: 8px;
                    content: ' ';
                    height: 18px;
                    width: 2px;
                    background-color: #000;
                }

                p.queryHeading {
                    color: #000;
                    font-weight: 600;
                    font-size: 22px;
                    line-height: 22px;

                }
            }

            div.contactManagementForm {
                color: #000;
                padding-top: 20px;
                font-family: 'Rubik';

                div.queryFormWrap {
                    margin-bottom: 10px;

                    p {
                        font-weight: 600;
                        margin-bottom: 10px;
                        letter-spacing: 0.2px;

                        span.redText {
                            color: #eb2026;
                        }
                    }

                    input {
                        width: 100%;
                        border: 1px solid #c8c8c8;
                        border-radius: 4px;
                        padding: 10px;
                        height: 41px;
                        font-size: 14px;
                        line-height: 14px;
                        outline: none;
                    }

                    div.err {
                        margin-top: 5px;
                        color: #eb2026;
                        --borderColor: #eb2026;
                    }
                }

                p.form_tnc {
                    position: relative;
                    padding: 5px 5px;
                    font-weight: 600
                }

                div.queryFormFooterBtn {
                    text-align: center;
                    margin-bottom: 10px;
                    margin-top: 5px;

                    button.primaryBtn.fill {
                        background: var(--color-btn-primary-bg, linear-gradient(93deg, #53b2fe, #065af3));
                        box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
                        color: #fff;
                        border-radius: var(--radius-btn-primary, 34px);
                        flex-shrink: 0;
                        display: inline-block;
                        text-transform: uppercase;
                        cursor: pointer;
                        outline: 0;
                        border: 0;
                        text-align: center;
                        font-weight: 900;
                        font-size: 12px;
                        padding: 9px 20px;
                    }
                }
            }
            div.seperation-section {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              margin-bottom: 10px;
               
                div.border-seperator {
                    width: 100%;
                    height: 1px;
                    background: #bdbdbd;
                    margin-right:10px;
                    margin-left:10px;
                }
            }     
        }
        p.or-text {
          font-size: 12px;
          font-weight: 600;
          color: #000;
        }
    }
`
);